<template>
  <div class="content basicsSetting">
    <template>
      <el-tabs>
        <template v-for="(item, index) in tabData">
          <el-tab-pane :label="item" :key="index">
            <div class="bodycontent">
                <!-- 今日统计 -->
                <div class="stat">
                  <div class="stat_title">数据概况信息</div>
                  <div class="stat_item">
                    <div class="item" v-for="item in statItems" :key="item.id" :style="{background:item.bgc}">
                      <div class="left"></div>
                      <div class="right">
                        <div class="top_line">{{item.value}}</div>
                        <div>{{item.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 用户数量 -->
                <div class="user">
                  <!-- 会员用户 -->
                  <div class="user_item">
                    <div class="user_title">访问信息
                      <span style="float:right">(单位:人)</span>
                    </div>
                    <div class="user_detail">
                      <div class="detail_item" v-for="item in user" :key="item.id">
                        <div class="item_num">{{item.num}}</div>
                        <div>{{item.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </el-tab-pane>
        </template>
      </el-tabs>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      listData: [], //列表
      page: 1,
      total: 0,
      loading: false, //页面loading
      tabData: ["今天", "本周", "本月"],
      statItems:[
        {name:'总访问量',value: '￥0.00',bgc:'#5cb87a'},
        {name:'总话题',value: '￥0.00',bgc:'#e6a23c'},
        {name:'昨日访问量',value: '￥0.00',bgc:'#f56c6c'},
        {name:'昨日活跃人数',value: '0',bgc:'#409eff'},
      ],
      user:[
        {name:'收藏数',num:'0'},
        {name:'评论数',num:'0'},
        {name:'本月新增',num:'0'},
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
    };
  },
  mounted() {
    console.log("router", this.$route);
    this.page_id = this.$route.params.id;
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  .bodycontent {
    position: relative;
    padding: 20px;
    font-size: 14px;
    height: 100%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .stat{
      border: 1px solid #eee;
      .stat_title{
        border-bottom: 1px solid #eee;
        background-color: #f5f5f5;
        color: #333;
        padding-left: 15px;
        font-weight: 500;
        height: 40px;
        line-height: 40px;
      }
      .stat_item{
        display: flex;
        justify-content: space-between;
        padding: 15px 10px;
        .item{
          flex:1;
          border-radius: 5px;
          height: 120px;
          box-shadow:0px 0px 6px 0px rgba(0,0,0,0.07);
          padding: 30px;
          margin: 0 15px;
          color: #fff;
          .left{
            flex:1;
          }
          .right{
            div{
              line-height: 30px;
            }
            .top_line{
              font-size: 22px;
            }
          }
        }
      }
    }
    .user{
      margin-top: 30px;
      display: flex;
      .user_item{
        box-shadow:0px 0px 6px 0px rgba(0,0,0,0.07);
        height: 220px;
        padding:16px;
        flex:1;
        border-radius: 5px;
        .user_title{
          border-bottom: 1px solid #eee;
          font-weight: 500;
          height: 30px;
        }
        .user_detail{
          display: flex;
          justify-content: space-around;
          padding-top: 60px;
          .detail_item{
            div{
              text-align: center;
              line-height: 30px;
            }
            .item_num{
              font-size: 22px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.basicsSetting {
  .el-tabs__nav-scroll {
    padding-left: 25px;
  }
}
</style>
